export default {
  metrics: {
    go_lives: 'Go-lives i alt',
    avg_quality_score: 'Gennemsnitlig kvalitetsscore',
    managers: {
      title: 'Onboarding-managere',
      fields: {
        name: 'Managerens navn',
        go_lives: 'Go-lives',
        avg_quality_score: 'Gns. kvalitetsscore',
      },
    },
  },
  details: {
    name: 'Restaurant',
    owner: 'Ejerens navn',
    owner_phone: 'Ejerens telefon',
    owner_email: 'Ejerens e-mail',
    live_from: 'Go-live-dato',
    onboarding_manager: 'Onboarding-manager',
    sales_manager: 'Salgschef',
    onboarding_quality_score: 'Kvalitetsscore',
    export_csv: 'Eksportér CSV',
  },
};
